export default __webpack_public_path__ + "static/media/8601.065ffdc9.png";